import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'

import { EventLimits as EventLimitsField, LIMIT_TYPES } from 'components/event_type_edit'

import { AddButton } from '../../../components'
import {
  PanelContentContainer,
  PanelContentHeader,
  PanelContentSubtitle,
  PanelContentTitle,
  PanelContentValueLocked
} from '../styles'

const EventLimitsLocked = () => (
  <PanelContentContainer section>
    <PanelContentHeader isLocked>
      <PanelContentTitle>
        {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.max_meetings')}
      </PanelContentTitle>
      <PanelContentValueLocked>
        <EventLimitsField isLocked />
      </PanelContentValueLocked>
    </PanelContentHeader>
    <PanelContentSubtitle>
      {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.max_meetings_description')}
    </PanelContentSubtitle>
  </PanelContentContainer>
)

const EventLimitsSection = () => {
  const { values: { dailyLimit, weeklyLimit, monthlyLimit } } = useFormContext()
  const limitTypes = { dailyLimit, weeklyLimit, monthlyLimit }

  const observableLimitTypes = LIMIT_TYPES.filter((type) => limitTypes[type] !== undefined)

  return (
    <PanelContentContainer section data-testid="max_meetings_section">
      <PanelContentHeader>
        <PanelContentTitle>
          {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.max_meetings')}
        </PanelContentTitle>
        <PanelContentSubtitle>
          {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.max_meetings_description')}
        </PanelContentSubtitle>
      </PanelContentHeader>
      <PanelContentContainer subsection={observableLimitTypes.length !== 0}>
        <EventLimitsField v3Style addButtonComponent={AddButton} />
      </PanelContentContainer>
    </PanelContentContainer>
  )
}

export const EventLimits = ({ isLocked }) => (
  !isLocked ? <EventLimitsSection /> : <EventLimitsLocked />
)
